import api from "@/services/api"

type CheckUserConfirmedResponse =
  | {
      userIsConfirmed: false
    }
  | {
      userIsConfirmed: true
      merchantName: string
    }

export const checkUserConfirmed =
  async (): Promise<CheckUserConfirmedResponse> => {
    const { body: response_body } =
      await api.get<CheckUserConfirmedResponse>(
        "/onboarding/check-user-confirmed"
      )

    return response_body
  }
